module.exports = __webpack_public_path__ + "img/map.bab2b509.png";